import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Chip,
  Typography
} from '@mui/material';
import { CheckCircleOutlined, CancelOutlined, ToggleOnOutlined } from '@mui/icons-material';
import { selectSx, labelSx, placeholderSx, statusChipSx, statusColors } from '../../styles/wizardSx';

function BooleanField({ field, value, onChange, ...props }) {
  return (
    <FormControl fullWidth>
      <InputLabel sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        ...labelSx
      }}>
        <ToggleOnOutlined sx={{ fontSize: 16 }} />
        {field.label}
      </InputLabel>
      <Select
        value={value === true ? 'true' : value === false ? 'false' : ''}
        onChange={(e) => onChange(e.target.value === 'true')}
        label={field.label}
        sx={selectSx}
        {...props}
      >
        <MenuItem value="">
          <Typography component="span" sx={placeholderSx}>Select {field.label}</Typography>
        </MenuItem>
        <MenuItem value="true">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CheckCircleOutlined sx={(theme) => ({ color: statusColors(theme, 'success').text, fontSize: 18 })} />
            <span>Yes</span>
            <Chip label="True" size="small" sx={[{ height: '20px' }, statusChipSx('success')]} />
          </Box>
        </MenuItem>
        <MenuItem value="false">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CancelOutlined sx={(theme) => ({ color: statusColors(theme, 'error').text, fontSize: 18 })} />
            <span>No</span>
            <Chip label="False" size="small" sx={[{ height: '20px' }, statusChipSx('error')]} />
          </Box>
        </MenuItem>
      </Select>
    </FormControl>
  );
}

export default BooleanField;
